import React from 'react'
import PriceShowcase from './PriceShowcase'
import ReviewStars from './ReviewStars'
import {
  isEmptyString,
  isNil,
  isNonEmptyString,
  isNull,
  isNumber
} from '../../../utils/checks'
import Accreditation from './Accreditation'
import useIsMobile from '../../../hooks/useIsMobile'
import {
  getAccreditation,
  getSlug,
  getAcceptedInsuranceTitles
} from '../../../domain/center'
import { getSearchState } from '../../../utils/search/searchState'
import { shouldShowInsuranceTooltip } from '../../../domain/useCases/insurance/shouldShowInsuranceTooltip'
import PriceShowcasePopover from './PriceShowcasePopover'
import { Page } from '../../../types/models/PageType.model'

const CenterBadgesAndRatingSection = ({
  center,
  pageType,
  allReviewsCount,
  allReviewsWeightedAverage
}) => {
  const isMobile = useIsMobile()

  const searchState = getSearchState()
  const accreditation = getAccreditation(center)
  const slug = getSlug(center)
  const accepted_insurance = getAcceptedInsuranceTitles(center)

  const priceLabel = center.price_label || center.priceLabel
  const verify_insurance_link =
    center.verify_insurance_link || center.verifyInsuranceLink
  const insurance_description =
    center.insurance_description || center.insuranceDescription
  const pricing = center.pricing || center.priceLabel

  const showInsuranceTooltip = shouldShowInsuranceTooltip({
    acceptedInsurance: accepted_insurance,
    insuranceDescription: insurance_description,
    verifyInsuranceLink: verify_insurance_link
  })

  if (
    allReviewsCount === 0 &&
    isNil(priceLabel) &&
    isEmptyString(accreditation) &&
    !showInsuranceTooltip
  ) {
    return null
  }

  return (
    <div className="flex flex-row flex-wrap items-center gap-3">
      {isNumber(allReviewsCount) && (
        <ReviewStars
          reviewAverage={allReviewsWeightedAverage}
          reviewLength={allReviewsCount}
          slug={slug}
          premium
        />
      )}
      {isNonEmptyString(accreditation) && (
        <Accreditation accreditation={accreditation} />
      )}
      {pageType === Page.CENTER_PROFILE ? (
        <PriceShowcasePopover
          slug={slug}
          price_label={priceLabel}
          preventDefault={isMobile}
          accepted_insurance={accepted_insurance}
          insurance_description={insurance_description}
          verify_insurance_link={verify_insurance_link}
          isProfileIntro={true}
          currentRefinements={searchState?.refinementList}
        />
      ) : (
        <PriceShowcase
          slug={slug}
          price_label={priceLabel}
          price={pricing}
          preventDefault={isMobile}
          accepted_insurance={accepted_insurance}
          insurance_description={insurance_description}
          verify_insurance_link={verify_insurance_link}
          currentRefinements={searchState?.refinementList}
        />
      )}
    </div>
  )
}

export default CenterBadgesAndRatingSection
